import * as actionTypes from '../../action/dashboard/Dashboard'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: ''
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_DASHBOARD_FETCH:
            return {
                ...state,
                isFetching: true
            };
        case actionTypes.GET_DASHBOARD_SUCCESS :
            return {
                ...state,
                isFetching: false,
                error: false,
                dashboard: action.payload
            };
        
        case actionTypes.GET_DASHBOARD_FAILURE :
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_DASHBOARD_MESSAGE:
            return {
                ...state,
                isFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;